import React, { useState, useEffect } from "react";
import { FaBars } from "react-icons/fa";
import { Link } from "react-router-dom";


function MyNavbar() {
  const [isNavBarVisible, setIsNavBarVisible] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isVisible =
        prevScrollPos > currentScrollPos || currentScrollPos < 10;
      setIsNavBarVisible(isVisible);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  const [toggle, setToggle] = useState(false);

  const handleClick = () => {
    setToggle((toggle) => !toggle);
  };

  let myToggle = toggle ? " active" : "";

  return (
    <div>
      <nav className={`nav-bar${isNavBarVisible ? "" : " hidden"}`}>
        <Link to="/" className="nav-logo">
          <img id="mylogo" src="https://firebasestorage.googleapis.com/v0/b/myimages-10f37.appspot.com/o/mylogo.png?alt=media&token=98314096-b9a6-4a49-9f88-f493bd9d5a5d" alt="Logo" />
        </Link>
        <ul className={`nav-links${myToggle}`}>
          <li>
            <a href="#landing-page">Home</a>
          </li>
          <li>
            <a href="#services">Graphic Design</a>
          </li>
          <li>
            <a href="#services">Web Design</a>
          </li>
          <li>
            <a href="#frame">Animation</a>
          </li>

          <li>
            <a href="#team">Team & Contacts</a>
          </li>
        </ul>
        <a href="#section">
          <button type="button" className="btn btn-outline-warning">
            Get Started
          </button>
        </a>
        <FaBars id="menu-icon" onClick={handleClick} />
      </nav>
    </div>
  );
}

export default MyNavbar;
